import getOrdinalForGrade from "@/utils/numbers/getOrdinalForNumber/getOrdinalForNumber";
import { LangstonParameterSchema } from "../../LangstonParameterSchema";

interface ParamValueOption {
  value: string;
  label: string;
}

interface ParameterWithValues {
  key: string;
  values: ParamValueOption[];
  default?: string | number;
}

interface ParameterWithoutValues {
  key: string;
  default?: string | number;
}

type ParameterConfig = ParameterWithValues | ParameterWithoutValues;

export interface LunaChip {
  label: string;
  type: string;
  value: string;
  score: number;
  selected: boolean;
}

function hasValues(config: ParameterConfig): config is ParameterWithValues {
  return "values" in config && Array.isArray((config as any).values);
}

export const formatSelectedFilters = (
  selectedLunaChips: LunaChip[],
): LunaChip[] => {
  const keysToExtract = [
    "topics",
    "standards",
    "grade_levels",
    "article_type",
    "languages",
    "maturity_range",
  ];

  const labelMap: Record<string, Record<string, string>> = {};

  for (const [key, config] of Object.entries(LangstonParameterSchema)) {
    if (hasValues(config)) {
      for (const option of config.values) {
        if (!labelMap[key]) labelMap[key] = {};
        // @ts-ignore
        labelMap[key][option.value] = option.label;
      }
    }
  }

  return selectedLunaChips
    .filter(({ type }) => keysToExtract.includes(type))
    .map(({ type, value, label, ...rest }) => {
      let newLabel: string = label;

      if (type === "grade_levels") {
        newLabel = `${label}${getOrdinalForGrade(Number(label))} grade`;
      }

      if (type === "standards") {
        newLabel = label.split(":")[0] || "";
      }

      return { ...rest, type, value, label: newLabel };
    })
    .filter((f): f is LunaChip => Boolean(f.label));
};
